import { useQuery } from "@tanstack/react-query";
import { PauseCircle } from "lucide-react";
import { api } from "@/lib/api";

export function useAutomationsStatus() {
  return useQuery({
    queryKey: ["automations-status"],
    queryFn: async () => (await api.get("/automations/status")).data,
    staleTime: 5 * 60 * 1000,
  });
}

export function AutomationStoppedPill({ className = "", testid = "automation-stopped-pill" }) {
  const q = useAutomationsStatus();
  if (!q.data || q.data.enabled) return null;
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center gap-1.5 rounded-full border border-slate-300 bg-slate-100 px-2.5 py-1 text-[11px] font-medium text-slate-700 dark:border-slate-600 dark:bg-slate-800 dark:text-slate-200 ${className}`}
    >
      <PauseCircle className="h-3.5 w-3.5" />
      Automatización parada · solo ejecución manual
    </span>
  );
}
